import axios from "axios";
import { encryptStorage } from '@/utils/storage';
import { PbxProtocol } from "@/config";
import vueApp from "@/store";

/**
 * The apiClientLogin axios instance logic, was separated and is not included with the apiCient interceptors as it requires the token to send
 * the HTTP petion and initially to sign in the token hasn't been set on the local storage, therefore it might rise an error stating <Token invalid>
 * <This instance won't have interceptors to be able to log in and therefore set the token in the encryptStorage>
 */
export const apiClientLogin = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  //baseURL:'http://localhost:8001', 
  withCredentials: false,
});

export const apiClientRouter = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  //baseURL:'http://localhost:8001', 
  withCredentials: false,
});

apiClientRouter.interceptors.request.use((config) => {
  config.headers = {
    Authorization: "token " + vueApp.state.auth_store.userInfo.Token,
  };
  return config;
});

export const apiClientDescarga = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, 
  withCredentials: false,
});

apiClientDescarga.interceptors.request.use((config) => {
  config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`;
  return config;
});

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, 
  withCredentials: false,
});

apiClient.interceptors.request.use((config) => {
  config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`;
  // config.baseURL = 'http://localhost:8001';
  config.headers = {
    Authorization: "token " + vueApp.state.auth_store.userInfo.Token,
  };
  // console.log("Config from interceptor: ", config);
  return config;
});

export const apiClientFexeIA = axios.create({
  baseURL: process.env.VUE_APP_FEXEIA_API,
  withCredentials: false,
});

export const apiClientFexeIACache = axios.create({
  baseURL: process.env.VUE_APP_FEXEIA_CACHE_API,
  withCredentials: false,
});

apiClientFexeIACache.interceptors.request.use((config) => {
  config.headers = {
    "X-API-Key": process.env.VUE_APP_FEXEIA_CACHE_API_TOKEN,
  };
  return config;
});

export const apiClientDown = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
});

apiClientDown.interceptors.request.use((config) => {
  config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`
  return config;
});

export const apiClientDownloadFile = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
  responseType: 'blob',
  // headers: {
  //   Authorization: "Token " + encryptStorage.getItem("token"),
  // },
});

apiClientDownloadFile.interceptors.request.use((config) => {
  config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`
  config.headers = {
    Authorization: "token " + vueApp.state.auth_store.userInfo.Token,
  };
  //config.baseURL = 'http://localhost:8001';
  return config;
});

// reload token

export const reloadApiClient = () => {
  const token = encryptStorage.getItem("token")
  apiClient.defaults.headers.common["Authorization"] = `Token ${token}`
}

export const reloadApiClientDownloadFile = () => {
  const token = encryptStorage.getItem("token")
  apiClientDownloadFile.defaults.headers.common["Authorization"] = `Token ${token}`
}

export const reloadApiClientFormUpload = () => {
  const token = encryptStorage.getItem("token")
  apiClientFormUpload.defaults.headers.common["Authorization"] = `Token ${token}`
}

export const apiClientForm = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
});

apiClientForm.interceptors.request.use((config) => {
  config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`
  return config;
});

export const apiClientFormUpload = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
});

apiClientFormUpload.interceptors.request.use((config) => {
  config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`
  config.headers = {
    Authorization: "token " + vueApp.state.auth_store.userInfo.Token,
  };
  return config;
});

export const apiRequest = {
  getLabel(callDirection, number, userId, optionPush, token) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.get(
      `/api/pbx/get_call_info?call_direction=${callDirection}&number=${number}&user_id=${userId}&option_push=${optionPush}`
    );
  },
  getExtensionInfo(extension, token) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.get(`/api/pbx/get_extension_info?number=${extension}`);
  },
  convertSDP(localDescription, remoteDescription, token) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.post(
      `/api/pbx/translate_sdp?local=${localDescription}&remote=${remoteDescription}`
    );
  },
  getLastNumber(token, user) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.get(`/api/webrtc/last_call?endpoint=${user}`);
  },
  preTranslateNumber(token, callNumber) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.post(`/api/pbx/pre_translate?number=${callNumber}`);
  },
  pbxTransfer(transferType, transferTarget, call_id, user, token) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.post(
      `/zoho/api/zoho_transfer?endpoint=${user.User}&target=${transferTarget}&call_id=${call_id}&type=${transferType}`
    );
  },
  warnTransfer(transferPhase, call_id, user, token) {
    console.log("WARNTRANFER REQUEST: ", transferPhase, call_id, user, token);
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.post(
      `/zoho/api/transfer_event?endpoint=${user.User}&phase=${transferPhase}&call_id=${call_id}`
    );
  },
  rejectClickToCall(reason,user) {
    console.log('STORE: ',vueApp.state.softphone_store.ctxSip)
    let from = vueApp.state.softphone_store.ctxSip.clickToDial.from;
    let to = vueApp.state.softphone_store.ctxSip.clickToDial.to;
    return apiClient.post(
      `/zoho/api/reject_call?endpoint=${user.User}&from=${from}&to=${to}&reason=${reason}`
    );
  },
  getContacts(token) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${token}`;
    return apiClient.get("/api/webrtc/get_contacts");
  },
  removeConferenceMember(conferenceId, memberExtension, user) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${user.Token}`;
    return apiClient.post(
      `/zoho/api/remove_member?endpoint=${user.User}&conference_id=${conferenceId}&member=${memberExtension}`
    );
  },
  addConferenceMember(conferenceId, memberExtension, user) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${user.Token}`;
    return apiClient.post(
      `/zoho/api/add_member?endpoint=${user.User}&conference_id=${conferenceId}&member=${memberExtension}`
    );
  },
  toggleConferenceRecord(conferenceId, state, user) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${user.Token}`;
    return apiClient.post(
      `/zoho/api/toggle_record?endpoint=${user.User}&conference_id=${conferenceId}&state=${state}`
    );
  },
  removeInvitedChannel(conferenceId, targetEndpoint, user) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${user.Token}`;
    return apiClient.post(
      `/zoho/api/remove_invited?endpoint=${user.User}&conference_id=${conferenceId}&target_endpoint=${targetEndpoint}`
    );
  },
  // rejectConferenceInvitation(invitationData) {
  //   return apiClient.post(`/zoho/api/reject_invitation?invitor_endpoint=${invitationData.invitorEndpoint}&conference_id=${invitationData.conferenceId}&invitor_channel_id=${invitationData.invitorChannel}&invited_channel=${invitationData.invitedChannel}`)
  // },
  rejecttranferInvitation(transferCallId, transferType, user) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${user.Token}`;
    return apiClient.post(
      `/zoho/api/reject_transfer?call_id=${transferCallId}&transfer_type=${transferType}&endpoint=${user.User}`
    );
  },
  getPjsipContacts(user) {
    apiClient.defaults.headers.common["Authorization"] = `Token ${user.Token}`;
    return apiClient.get("/api/webrtc/pjsip_contacts");
  },
};
